module.exports = __webpack_public_path__ + "img/chara_line_1_white.2a5ad1ee.png";